import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useSetGameEnvironmentFromParam } from '../common/useSetGameEnvironmentFromParam';
import { EntityCalendar } from './EntityCalendar';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';

export const EntityCalendarContainer: FC = observer(() => {

  useSetGameEnvironmentFromParam();
  const { setPageTitle } = usePageTitle();

  setPageTitle(['Calendar']);

  return <EntityCalendar />;
});
